import { render, staticRenderFns } from "./ClientSubscriptions.vue?vue&type=template&id=9760aaae"
import script from "./ClientSubscriptions.vue?vue&type=script&lang=js"
export * from "./ClientSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports